import React, { useState } from "react";
import { setStatusClass } from "../../utils/styles";
import themePropTypes from "../theme-prop-types";

const Goal = ({ items, isInitiallyOpen, TaskList, settings }) => {
  const [isOpened, setIsOpened] = useState(isInitiallyOpen);

  const {
    title,
    subtitle,
    icon: { iconName }
  } = items[0];

  const icons = {
    icn_complete: "completeIcon",
    icn_flag: "flagIcon",
    icn_progress: "flagIco"
  };

  const arrows = {
    arrowTop: "td-arrow-top",
    arrowDown: "td-arrow-down"
  };

  const handleClick = e => {
    e.preventDefault();
    setIsOpened(prevState => !prevState);
  };

  const { collapsed, expanded } = settings.translations;

  return (
    <div className='goal'>
      <div className='goal-header'>
        <div className='content-wrapper'>
          <div
            className={`goal-icon-web-sdk ${icons[iconName]}`}
            data-testid='target-icon'
          />
          <div className='goal-info'>
            <p className='title'>{title.text}</p>
            <div className='status-date-wrapper'>
              <p
                className={`status ${setStatusClass(
                  subtitle.text.split("|")[0].trim()
                )}`}
              >
                {subtitle.text.split("|")[0].trim()}
              </p>
              {subtitle.text.split("|").length === 2 && (
                <p className='date'>{subtitle.text.split("|")[1].trim()}</p>
              )}
            </div>
          </div>
        </div>
        <button
          onClick={handleClick}
          className='button-collapse'
          type='button'
          aria-label={
            isOpened
              ? `${title.text} ${expanded}`
              : `${title.text} ${collapsed}`
          }
        >
          <span className={isOpened ? arrows.arrowTop : arrows.arrowDown} />
        </button>
      </div>
      <div
        data-testid='goal-body'
        className={`goal-body ${isOpened ? "" : "closed"}`}
      >
        <p className='tasks-header'>{settings.translations.tasks}</p>
        <TaskList tasks={items.slice(3)} />
      </div>
    </div>
  );
};

Goal.propTypes = themePropTypes.goal;

export default Goal;
